import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {ReportCycleSearch} from '../../../admin/models/report-cycle-search.interface';
import {DatePipe} from '@angular/common';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-report-cycles-filter',
  templateUrl: './report-cycles-filter.component.html',
  styleUrls: ['./report-cycles-filter.component.scss']
})
export class ReportCyclesFilterComponent implements OnInit {

  searchForm = this.formBuilder.group({
    startYear: [''],
    endYear: [''],
    unuKey: [''],
    kfCategory: [''],
    collectionStream: [''],
    isLaunch: [],
    startLaunched: [''],
    endLaunched: [''],
    open: []
  });

  get startYearControl(): FormControl {
    return this.searchForm.get('startYear') as FormControl;
  }

  get endYearControl(): FormControl {
    return this.searchForm.get('endYear') as FormControl;
  }

  get unuKeyControl(): FormControl {
    return this.searchForm.get('unuKey') as FormControl;
  }

  get kfCategoryControl(): FormControl {
    return this.searchForm.get('kfCategory') as FormControl;
  }

  get collectionStreamControl(): FormControl {
    return this.searchForm.get('collectionStream') as FormControl;
  }

  get isLaunchControl(): FormControl {
    return this.searchForm.get('isLaunch') as FormControl;
  }

  get startLaunchedControl(): FormControl {
    return this.searchForm.get('startLaunched') as FormControl;
  }

  get endLaunchedControl(): FormControl {
    return this.searchForm.get('endLaunched') as FormControl;
  }

  get openControl(): FormControl {
    return this.searchForm.get('open') as FormControl;
  }

  @Output()
  search: EventEmitter<ReportCycleSearch> = new EventEmitter<ReportCycleSearch>();

  constructor(private formBuilder: FormBuilder,
              private datePipe: DatePipe,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.setFormValuesFromQueryParams();
  }

  handleSubmit(): void {
    const dto: ReportCycleSearch = {
      startYear: this.startYearControl.value,
      endYear: this.endYearControl.value,
      unuKeyName: this.unuKeyControl.value,
      kfCategoryName: this.kfCategoryControl.value,
      collectionStreamName: this.collectionStreamControl.value,
      launched: this.isLaunchControl.value !== 'no',
      startLaunched: this.datePipe.transform(this.startLaunchedControl.value, 'yyyy-MM-dd HH:mm:ss'),
      endLaunched: this.datePipe.transform(this.endLaunchedControl.value, 'yyyy-MM-dd HH:mm:ss'),
      open: this.openControl.value,
    };
    this.search.emit(dto);
  }

  clean(): void {
    this.search.emit({});
  }

  private setFormValuesFromQueryParams(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.startYear) {
        this.searchForm.get('startYear')?.setValue(params.startYear);
      }
      if (params.endYear) {
        this.searchForm.get('endYear')?.setValue(params.endYear);
      }
      if (params.unuKeyName) {
        this.searchForm.get('unuKeyName')?.setValue(params.unuKeyName);
      }
      if (params.kfCategoryName) {
        this.searchForm.get('kfCategoryName')?.setValue(params.kfCategoryName);
      }
      if (params.collectionStreamName) {
        this.searchForm.get('collectionStreamName')?.setValue(params.collectionStreamName);
      }
      if (params.launched) {
        this.searchForm.get('launched')?.setValue(params.launched);
      }
      if (params.startLaunched) {
        this.searchForm.get('startYear')?.setValue(params.startYear);
      }
      if (params.endLaunched) {
        this.searchForm.get('startLaunched')?.setValue(params.startLaunched);
      }
      if (params.open) {
        this.searchForm.get('open')?.setValue(params.open);
      }
      if (params.schemaKind) {
        this.searchForm.get('schemaKind')?.setValue(params.schemaKind);
      }

    });
  }
}
